import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import { END } from 'redux-saga';
import { wrapper, SagaStore } from 'store';
import { GetStaticProps } from 'next';
import {
  GET_AWARD,
  GET_FOOTER,
  GET_HOME,
  GET_LISTSPL,
  GET_NEWS,
  GET_SEO,
  GET_TRANSLATE,
} from '@containers/Home/slice';
import { useSelector } from 'react-redux';
import { selectSeo } from '@containers/Home/selectors';
import { useRouter } from 'next/router';

const Home = dynamic(() => import('containers/Home'), {
  loading: () => <span>Loading</span>,
});

function PublicContainer() {
  const seo = useSelector(selectSeo);
  const router = useRouter();
  const canonical =
    (typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL || '') + router.asPath;

  return (
    <>
      <NextSeo
        title={seo?.title || ''}
        description={seo?.description || ''}
        canonical={canonical}
        openGraph={{
          type: 'website',
          title: seo?.title || '',
          description: seo?.description || '',
          images: seo?.image
            ? [
                {
                  url: seo?.image,
                  width: 800,
                  height: 600,
                  alt: '',
                },
              ]
            : [],
        }}
      />
      <Home />
    </>
  );
}
export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  store =>
    async ({ locale }) => {
      await store.dispatch(
        GET_SEO({ locale, url: `home?SiteCode=SunParadiseLand` }),
      );
      await store.dispatch(GET_HOME({ locale }));
      await store.dispatch(GET_AWARD({ locale }));
      await store.dispatch(GET_NEWS({ park: 'SunParadiseLand', locale }));
      await store.dispatch(GET_FOOTER({ locale }));
      await store.dispatch(GET_TRANSLATE({ locale }));
      await store.dispatch(GET_LISTSPL({ locale }));
      store.dispatch(END);
      await (store as SagaStore).sagaTask?.toPromise();
      return {
        props: {},
        revalidate: 20,
      };
    },
);
export default PublicContainer;
